module.exports = __webpack_public_path__ + "typescript-gears.3wDOtFIX.svg";